import {AvisInitialTypeLight} from './AvisInitialTypeLight';
import {TypeDescMarche} from './TypeDescMarche';
import { TypeLieu } from './TypeLieu';
export class Annulation {

	public infosAnnulation: string;

	public avisInitial: AvisInitialTypeLight;

	public description: TypeDescMarche;

	public typeProcedure: string;

	public objet: string;

	public lieuExecutionLivraison: TypeLieu;

	public lieuExecution: TypeLieu;

	public lieuLivraison: TypeLieu;

	constructor() {
		this.infosAnnulation = '';
		this.avisInitial = new AvisInitialTypeLight();
		this.description = new TypeDescMarche();
		this.typeProcedure = '';
		this.objet = '';
		this.lieuLivraison = new TypeLieu();
		this.lieuExecutionLivraison = new TypeLieu();
		this.lieuExecution = new TypeLieu();
	}
}
